export { default } from './FormInfoCategory.vue'
